const en = {
  // Navigation & Layout
  nav: {
    kreation: 'Creation',
    kreationDesc: 'Generate content ideas',
    produktion: 'Production',
    produktionDesc: 'Edit content',
    distribution: 'Distribution',
    distributionDesc: 'Schedule content',
    settings: 'Settings',
    settingsDesc: 'Profile & Company',
    profile: 'Profile',
    logout: 'Log out',
    user: 'User',
    impressum: 'Legal Notice',
    datenschutz: 'Privacy Policy',
    brandUpgraded: 'Your brand profile has been automatically upgraded to the new Brand DNA!',
  },

  // Common / Shared
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    loading: 'Loading...',
    generating: 'Generating...',
    failed: 'Failed',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    draft: 'Draft',
    scheduled: 'Scheduled',
    published: 'Published',
    archived: 'Archived',
    characters: 'characters',
    words: 'words',
    toasts: {
      deleted: 'Deleted',
      undo: 'Undo',
      deleteFailed: 'Delete failed',
      restoreFailed: 'Restore failed',
      movedTo: 'Moved to {date}',
      moveFailed: 'Move failed',
      linkedinApproved: 'Approved for LinkedIn',
      linkedinUnapproved: 'LinkedIn approval revoked',
      pinterestApproved: 'Approved for Pinterest',
      pinterestUnapproved: 'Pinterest approval revoked',
      genericError: 'Error',
      loadContentFailed: 'Failed to load content',
      contentPiecesCreated: '{n} content piece{s} created!',
      contentPiecesGenerated: '{n} content piece{s} successfully generated!',
      generationTakingLonger: '{n} piece{s} are taking longer than usual — please try again shortly. Your quota won\'t be charged.',
      allPiecesReady: 'All pieces are ready now.',
      generationSlow: 'Generation taking longer than usual — please try again shortly. Your quota won\'t be charged.',
      statusUpdated: 'Status updated',
      scriptSubmitted: 'Script submitted for video generation',
      approveFailed: 'Approval failed',
      maxImagesPerPost: 'You can only post a maximum of {max} {imageWord} per post on {platform}. Please adjust your selection.',
      imageWordSingular: 'image',
      imageWordPlural: 'images',
      uploadFailed: 'Upload failed',
      approvedWithDrafts: 'Approved + {n} new drafts created',
      approvedInCalendar: 'Approved and saved in calendar',
      statusChangeFailed: 'Status change failed',
      submitFailed: 'Failed to submit for generation',
      addFailed: 'Failed to add',
      tagError: 'Tag error',
    },
    items: 'items',
    of: 'of',
    noResults: 'No results',
    tryAgain: 'Try again',
    approve: 'Approve',
    duplicate: 'Duplicate',
    restore: 'Restore',
    undo: 'Undo',
    regenerate: 'Regenerate',
    platform: 'Platform',
    noFolder: 'No folder',
    max: 'Max.',
    chars: 'chars',
    images: 'images',
    download: 'Download',
    selected: 'selected',
    selectAll: 'Select all',
  },

  // Platforms
  platforms: {
    x: 'X',
    linkedin: 'LinkedIn Post',
    linkedin_artikel: 'LinkedIn Article',
    instagram: 'Instagram',
    facebook: 'Facebook',
    pinterest: 'Pinterest',
    medium: 'Medium',
    blog: 'Blog Article',
    newsletter: 'Newsletter',
    pressemitteilung: 'Press Release',
    youtube: 'YouTube',
  },

  // Onboarding
  onboarding: {
    loading: 'Loading...',
    alreadyRegistered: 'Already registered? Sign in',
  },

  // Step 1 — Website Analysis
  step1: {
    title: 'Tell us about your company',
    subtitle: 'We\'ll analyse your website and understand your business.',
    urlPlaceholder: 'Your website URL',
    analyzeBtn: 'Analyse',
    analyzingTitle: 'Analysing your company…',
    analyzingSubtitle: 'This will only take a moment.',
    invalidUrl: 'Please enter a valid URL',
    analysisSuccess: 'Analysis complete',
    analysisFailed: 'Analysis failed',
    resultTitle: 'Analysis complete',
    resultSubtitle: 'Here is your comprehensive company and content strategy analysis.',
    yourCompany: 'Your company',
    industry: 'Industry',
    uspsLabel: 'Unique selling points (USPs)',
    languageStyle: 'Language style',
    address: 'Tone',
    keywords: 'Keywords',
    targetAudiences: 'Target audiences',
    audience: 'Audience',
    marketingGoals: 'Marketing goals',
    channelMix: 'Recommended channel mix',
    perWeek: 'x/week',
    contentThemes: 'Content themes',
    onBrandNote: 'This information will be used to keep all your content on-brand.',
    continueBtn: 'Continue',
  },

  // Kreation Page
  kreation: {
    title: 'Content Creation',
    subtitle: 'Create content from AI-generated ideas or your own descriptions',
    newContent: 'New Content',
    newContentDesc: 'Describe your topic and choose platforms',
    contentIdeas: 'Content Ideas',
    refreshIdeas: 'New Ideas',
    ideasLoaded: 'New ideas loaded',
    ideasFailed: 'Could not load ideas',
    ideaRejected: 'Idea rejected',
    actionFailed: 'Action failed',
    generateFromIdea: 'Content generated from idea!',
    generateBtn: 'Generate content',
    generateIdea: 'Generate idea',
    editBtn: 'Edit',
    rejectBtn: 'Reject',
    describeTopic: 'Describe your topic or paste text...',
    describeRequired: 'Please describe what you want to communicate',
    platformRequired: 'Please select at least one platform',
    generationFailed: 'Content generation failed',
    limitReached: 'You have reached your monthly limit. Content generation is not possible.',
    limitReachedShort: 'You have reached your monthly limit',
    videoLimit: 'Video limit reached: You have already generated {limit} videos this month.',
    selectPlatforms: 'Output formats',
    imageElement: 'Image element',
    hauptprodukt: 'Main product',
    markengesicht: 'Brand face',
    keepInputText: 'Use own text',
    keepPhotos: 'Use own photos',
    uploadFiles: 'Upload files',
    generating: 'Content is being generated...',
    contentsGenerated: 'Contents created',
    existingContent: 'Existing Content',
    noContent: 'No content created yet',
    toProduction: 'To Production',
    tabs: {
      manual: 'Custom Content',
      ideas: 'AI Ideas',
    },
    tokenLimitBody: 'You have used up your token limit. Usage resets at the beginning of each month.',
    togetherCreatedPre: 'Together we have already created',
    togetherCreatedPost: 'Ready for more?',
    refImages: {
      title: 'Reference image(s) for this post (style) — up to 4',
      ownTile: 'Own',
      ownAlt: 'Own reference image',
      thumbAlt: 'Reference image',
      hintCustom: 'The generated image will follow your uploaded reference image. Tap another tile to switch.',
      hintSelectedOne: 'The generated image will follow {n} selected reference image (max 4).',
      hintSelectedMany: 'The generated image will follow {n} selected reference images (max 4).',
      hintNone: 'No reference image selected — all brand references will be used as the style source.',
    },
    multiLang: {
      hint: 'Multiple languages = 1 post in all languages. First = primary.',
      primary: 'Primary',
    },
    platformsSelected: 'formats selected (max. {{max}} for reliable generation)',
    ideaPlaceholderPrefix: 'e.g. ',
    describeTopicFallback: 'Describe your topic or paste a text…',
  },

  // Produktion Page
  produktion: {
      retry: {
        button: 'Try again',
        buttonShort: 'Retry',
        starting: 'Starting…',
        generatingTitle: 'Generating…',
        restarted: 'Generation restarted.',
        failedAgain: 'Retry failed — please contact support.',
        ready: 'Content is ready.',
        couldNotStart: 'Could not start the retry.',
      },
      imageGen: {
        unknownError: 'unknown error',
        failed: 'Image generation failed: {msg}. Your quota will not be charged.',
      },
    title: 'Content Production',
    subtitle: 'Edit and refine your content',
    allContent: 'All Content',
    drafts: 'Drafts',
    scheduled: 'Scheduled',
    published: 'Published',
    deleted: 'Deleted',
    noContent: 'No content available',
    noContentDesc: 'Create your first content in Creation',
    goToKreation: 'Go to Creation',
    editContent: 'Edit content',
    regenerateText: 'Regenerate text',
    regenerateImage: 'Regenerate image',
    textRegenerated: 'Text has been regenerated',
    imageRegenerated: 'Image has been regenerated',
    regenerationFailed: 'Regeneration failed',
    deleteContent: 'Delete content',
    deleteConfirm: 'Do you really want to delete this content?',
    contentDeleted: 'Content deleted',
    contentRestored: 'Content restored',
    restore: 'Restore',
    schedule: 'Schedule',
    scheduleContent: 'Schedule content',
    scheduledSuccess: 'Content scheduled',
    publishNow: 'Publish now',
    saveChanges: 'Save changes',
    changesSaved: 'Changes saved',
    saveFailed: 'Save failed',
    textContent: 'Text Content',
    headline: 'Headline',
    hashtags: 'Hashtags',
    imagePrompt: 'Image Prompt',
    pinTitle: 'Pin Title',
    pinDescription: 'Pin Description',
    videoScript: 'Video Script',
    videoTitle: 'Video Title',
    videoDescription: 'Video Description',
    videoTags: 'Video Tags',
    pressHeadline: 'Headline',
    pressSubtitle: 'Subtitle',
    pressShortText: 'Short Text',
    pressBodyText: 'Body Text',
    pressKeywords: 'Keywords',
    pressCompanyDesc: 'Company Description',
    version: 'Version',
    versions: 'Versions',
    currentVersion: 'Current Version',
    previousVersions: 'Previous Versions',
    contentNumber: 'Content No.',
    createdAt: 'Created on',
    lastEdited: 'Last edited',
    platform: 'Platform',
    status: 'Status',
    language: 'Language',
    comments: 'Comments',
    addComment: 'Add comment',
    commentPlaceholder: 'Write a comment...',
    commentAdded: 'Comment added',
    noComments: 'No comments yet',
    copyText: 'Copy text',
    textCopied: 'Text copied',
    downloadImage: 'Download image',
    fullscreen: 'Fullscreen',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    search: 'Search: Title, Keywords, #ID...',
    allPlatforms: 'All Platforms',
    select: 'Select',
    folderName: 'Folder name...',
    createTags: 'Create tags',
    manageTags: 'Manage Tags',
    newTagName: 'New tag name...',
    noTagsYet: 'No tags created yet',
    deleteCount: 'Delete',
    postsDeleted: 'posts deleted',
    bulkDeleteTitle: 'Are you sure?',
    tryDifferentFilters: 'Try different filters',
    generateImage: 'Generate Image',
    imageLoading: 'Loading...',
    expand: 'Expand',
    moveToFolder: 'Move to folder',
    removeFromFolder: 'Remove from folder',
    noFoldersYet: 'No folders created yet',
    firstComment: 'Add the first comment',
    videoGenerating: 'Video is being generated...',
    chooseFromGallery: 'Choose from Gallery',
    charactersLabel: 'Characters',
    versionsLabel: 'Versions',
    versionSingular: 'Version',
    versionLoaded: 'Version {n} loaded',
    approveDialogTitle: 'Approve Content',
    approveDialogQuestion: 'Should this content also be prepared for another platform?',
    aiCalculatingTime: 'AI is calculating optimal posting time...',
    aiRecommendation: 'AI Recommendation',
    dateLabel: 'Date',
    timeLabel: 'Time',
    plannedPublication: 'Planned publication',
    atTime: 'at {time}',
    autoPostOn: 'Automatically post to {platform}',
    maxCharsExceeded: 'On {platform}, you can only post a maximum of {max} characters per post. Your text has {count} characters. Please shorten your text accordingly.',
    charsTooMany: '{n} too many!',
    aiReasonDefault: 'Optimal posting time based on platform data.',
    clearSelection: 'Clear selection',
    fromGallery: 'From Gallery',
    scheduledDate: 'Scheduled date',
    schedulePost: 'Schedule Post',
    scheduleInCalendar: 'Schedule in Calendar',
    scheduledInCalendar: 'Scheduled in calendar!',
    adaptChannels: 'Adapt for other channels?',
    noThanks: 'No thanks',
    channelsAdapt: 'channels adapt',
    selectChannels: 'Select channels',
    postAlreadyScheduled: 'Post already scheduled',
    scheduledAt: 'Scheduled at: ',
    replaceScheduled: 'Replace scheduled post',
    saveAsDraft: 'Save changes as draft',
    aiRefineText: 'AI Instruction — Refine text',
    aiRefinePlaceholder: 'e.g. "Shorten by half", "More formal", "More emojis"',
    aiGenerateImage: 'Generate AI Image',
    aiGenerateImageTitle: 'Your own idea? Create with AI instruction',
    aiGenerateImagePlaceholder: 'e.g. "Brighter colors", "More nature", "Minimalist"',
    aiRefineImage: 'Refine image with AI',
    saveImages: 'Save images',
    imagesSaved: 'Images saved',
    textRefined: 'Text refined!',
    imageGenerated: 'New image generated!',
    refinementFailed: 'Refinement failed',
    commentFailed: 'Could not post comment',
    commentDeleted: 'Comment deleted',
    tagCreated: 'Tag created',
    tagDeleted: 'Tag deleted',
    folderCreated: 'Folder created',
    folderRenamed: 'Folder renamed',
    folderDeleted: 'Folder deleted',
    movedToFolder: 'Moved to folder',
    removedFromFolder: 'Removed from folder',
    saved: 'Saved',
    deleteFailed: 'Delete failed',
    restored: 'Restored',
    restoreFailed: 'Restore failed',
    schedulingFailed: 'Scheduling failed',
    savedAsDraft: 'Saved as draft',
    justNow: 'Just now',
    takeMoment: 'This may take a moment',
    deletePermanently: 'Delete permanently',
  },

  // Distribution Page
  distribution: {
    title: 'Content Distribution',
    subtitle: 'Plan and manage your content publications',
    calendar: 'Calendar',
    list: 'List',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    newPost: 'New Post',
    schedulePost: 'Schedule Post',
    scheduledPosts: 'Scheduled Posts',
    noScheduled: 'No scheduled posts',
    noScheduledDesc: 'Schedule your content via the calendar',
    publishNow: 'Publish now',
    publishSuccess: 'Successfully published',
    publishFailed: 'Publication failed',
    selectDate: 'Select date',
    selectTime: 'Select time',
    selectContent: 'Select content',
    selectBoard: 'Select board',
    pinLink: 'Pin Link',
    connectedAccounts: 'Connected Accounts',
    noAccounts: 'No accounts connected',
    connectAccount: 'Connect account',
    syncStatus: 'Sync Status',
    synced: 'Synced',
    pending: 'Pending',
    errorSync: 'Sync Error',
    deleteEvent: 'Delete event',
    eventDeleted: 'Event deleted',
    eventScheduled: 'Event created',
    eventUpdated: 'Event updated',
    manualPost: 'Manual Post',
    fromContent: 'From Content',
    enterText: 'Enter text...',
    characters: 'characters',
    addManualContent: 'Add manually created content to the calendar.',
    videoOptional: 'Video (optional, max 100MB)',
    uploadingVideo: 'Uploading video...',
    uploadVideo: 'Upload video (MP4, MOV, WebM)',
    bestTimeSuggested: 'Best time suggested',
    uploadVideoShort: 'Upload video',
    duplicatePost: 'Duplicate post',
    postingFailed: 'Posting failed',
    reschedule: 'Reschedule',
    downloadingVideo: 'Downloading video...',
    platformLabel: 'Platform',
    dateTime: 'Date & Time',
    duplicateBtn: 'Duplicate',
    postCreated: 'Post created',
    postCreateFailed: 'Error creating post',
    changesSaved: 'Changes saved',
    saveFailed: 'Save failed',
    provideDatetime: 'Please provide date & time',
    duplicated: 'Post duplicated',
    duplicateFailed: 'Duplication failed',
    linkedinPosted: 'Posted on LinkedIn!',
    linkedinFailed: 'LinkedIn posting failed',
    pinterestPosted: 'Pinned on Pinterest!',
    pinterestFailed: 'Pinterest posting failed',
    selectPinterestBoard: 'Please select a Pinterest board',
    rescheduledFailed: 'Failed again — please check the error message',
    rescheduled: 'Successfully rescheduled!',
    rescheduleFailed: 'Reschedule failed',
    restored: 'Restored',
    fillRequiredFields: 'Please fill in all required fields',
    pinTitleRequired: 'Pin title is required',
    pinTitleTooLong: 'Pin title max. 100 characters',
    pinDescTooLong: 'Pin description max. 500 characters',
    pinImageRequired: 'Pinterest pins require an image',
    textRequired: 'Text is required',
    imagesUploaded: 'image(s) uploaded',
    imageNotFile: 'is not an image file',
    imageTooLarge: 'is too large (max 10MB)',
    uploadFailed: 'Upload failed',
    maxImages: 'Maximum {{max}} images for this platform',
    onlyVideoAllowed: 'Only video files allowed (MP4, MOV, AVI, WebM)',
    videoTooLarge: 'Video too large (max 100MB)',
    videoUploaded: 'Video uploaded',
    videoUploadFailed: 'Video upload failed',
    noPosts: 'No posts',
    noPostings: 'No posts',
    pressRelease: 'Press Release',
    textPlaceholder: 'Your post text...',
    dateTimeRequired: 'Date & Time *',
    cancel: 'Cancel',
    create: 'Create',
    detail: {
      scheduledFor: 'Scheduled for',
      status: 'Status',
      pinTitle: 'Pin Title',
      pinDescription: 'Pin Description',
      noTitle: 'No title available',
      noDescription: 'No description available',
      descriptionCopied: 'Description copied!',
      copy: 'Copy',
      link: 'Link',
      text: 'Text',
      textCopied: 'Text copied!',
      image: 'Image',
      imagesPlural: 'Images ({n})',
      downloadingImages: 'Downloading images...',
      download: 'Download',
      video: 'Video',
      viewInProduction: 'View in Production',
      postedToLinkedin: 'Posted on LinkedIn',
      postToLinkedin: 'Post to LinkedIn',
      postNow: 'Post now',
      scheduledShort: 'Scheduled',
      atScheduledTime: 'At scheduled time',
      autoPostedAt: 'Will be posted automatically on {date}',
      errorLabel: 'Error:',
      postedToPinterest: 'Posted on Pinterest',
      pinterestNeedsImage: 'Pinterest pins need at least one image',
      postToPinterest: 'Post to Pinterest',
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      noChannelConnected: 'No channel is connected for this platform yet.',
      publishFailedGeneric: 'The post could not be published. Please try again.',
      errorCodes: {
        media_unreachable: 'The image or video could not be loaded. Please check the media URL or re-upload the file.',
        aspect_ratio: 'The aspect ratio of the media is not supported by this platform. Please choose a suitable format (e.g. 1:1, 4:5 or 9:16).',
        media_too_large: 'The media file is too large for this platform. Please upload a smaller file.',
        media_unsupported: 'The file format is not supported by this platform.',
        text_too_long: 'The text exceeds this platform\'s character limit. Please shorten it and try again.',
        auth_expired: 'The connection to the account has expired. Please reconnect the account in the Integrations section.',
        insufficient_permissions: 'The connected account is missing permissions for this action. Please reconnect it in the Integrations section and grant all permissions.',
        rate_limited: 'Too many requests to the platform. Please try again in a few minutes.',
        duplicate_post: 'This post was recently already published. Please slightly adjust the content or remove the duplicate.',
        account_missing: 'The connected account could not be found on PostPeer. Please review the mapping in the admin panel and reconnect if needed.',
        schedule_invalid: 'The scheduled time is invalid or lies in the past. Please pick a new time with a timezone.',
        validation_error: 'A required field is missing or invalid. Please check text, media, and schedule.',
        upstream_unavailable: 'The platform is temporarily unreachable. Please try again in a few minutes.',
        no_channel_connected: 'No channel is connected for this platform yet.',
        generic: 'The post could not be published. Please try again. If the problem persists, contact support.',
      },
    },
  },

  // Settings Page
  settings: {
    styleStrength: {
      title: 'Style fidelity to references',
      description: 'How closely should the image match your references? Applies to every image generation.',
      lockerLabel: 'Loose',
      lockerDesc: 'Colour palette & mood as loose inspiration',
      treffenLabel: 'Close',
      treffenDesc: 'Stay on brand style, but adapt flexibly',
      exaktLabel: 'Exact',
      exaktDesc: 'Reproduce references as precisely as possible',
      saved: 'Style fidelity saved',
      saveError: 'Could not save style fidelity',
    },
    title: 'Settings',
    subtitle: 'Manage your profile and company settings',
    tabs: {
      company: 'Company',
      brand: 'Brand Style',
      channels: 'Channels',
      preferences: 'Preferences',
    },
    company: {
      name: 'Company Name',
      industry: 'Industry',
      activities: 'Core Business',
      targetAudience: 'Target Audience',
      usps: 'USPs (Unique Selling Points)',
      keywords: 'Keywords',
      save: 'Save company profile',
      saved: 'Company profile saved',
      // audit iter113
      coreBusinessPlaceholder: 'What does your company do?',
      audiencePlaceholder: 'e.g. B2B companies, consumers aged 25-45',
      industryPlaceholder: 'e.g. Technology, Health, E-commerce',
      addUspPlaceholder: 'Add new USP...',
      companyDataTitle: 'Company data',
      companyDataDesc: 'Analyze your website or edit the data manually — used for content and idea generation',
      urlAnalyzeDesc: 'Enter your website URL and start the analysis, or fill in the fields manually',
      saveChanges: 'Save changes',
      exampleCountry: 'e.g. United States',
    },
    brand: {
      title: 'Brand Style & Brand DNA',
      toneOfVoice: 'Tone of Voice',
      addressing: 'Addressing',
      formality: 'Formality',
      writingStyle: 'Writing Style',
      characteristics: 'Characteristics',
      signatureWords: 'Signature Words',
      addWord: 'Add word',
      brandSummary: 'Brand Summary',
      doList: "Do's",
      dontList: "Don'ts",
      inspirations: 'Inspirations',
      addInspiration: 'Add inspiration',
      brandMedia: 'Brand Media',
      uploadMedia: 'Upload media',
      styleTemplates: 'Style Templates',
      reanalyze: 'Re-analyze Brand DNA',
      analyzing: 'Analyzing...',
      analyzed: 'Brand DNA updated',
      analysisFailed: 'Analysis failed',
    },
    channels: {
      title: 'Connected Channels',
      connect: 'Connect',
      disconnect: 'Disconnect',
      connected: 'Connected',
      notConnected: 'Not connected',
      connectLinkedIn: 'Connect LinkedIn',
      connectPinterest: 'Connect Pinterest',
    },
    preferences: {
      title: 'Preferences',
      contentLanguage: 'Content Language',
      contentLanguageDesc: 'Default language for all platforms. Can be overridden for each platform.',
      imageStyle: 'Image Style',
      imageStyleDesc: 'Which image style do you prefer?',
      illustrations: 'Illustrations',
      aiPeople: 'AI People',
      photography: 'Photography',
      mixed: 'Mixed',
      saved: 'Preferences saved',
      saveFailed: 'Save failed',
    },
    integrationsTab: 'Integrations',
    personalInfo: 'Personal Information',
    personalInfoDesc: 'Update your account information',
    billing: 'Billing',
    emailImmutable: 'Email cannot be changed',
    passwordChange: 'Change Password',
    passwordSet: 'Set Password',
    passwordFirstTimeHint: 'Your account was set up via magic link. Set a password now to also sign in the classic way.',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    password: 'Password',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    companyAnalysis: 'Company Analysis',
    regenerate: 'Regenerate',
    brandDnaRegenerated: 'Brand DNA regenerated',
    brandDnaRegenerateFailed: 'Failed to regenerate',
    dnaFieldLabels: {
      usp: 'Unique Selling Point',
      market_position: 'Market Position',
      positioning: 'Positioning',
      product_promise: 'Product Promise',
      address_form: 'Salutation',
      formality_level: 'Formality Level',
      personality_traits: 'Personality Adjectives',
      dos: "Do's",
      donts: "Don'ts",
      forbidden_phrases: 'Forbidden Phrases',
      mandatory_elements: 'Mandatory Elements',
      headline_words_min: 'Headline Min.',
      headline_words_max: 'Headline Max.',
      body_words_min: 'Body Min.',
      body_words_max: 'Body Max.',
      hashtags_min: 'Hashtags Min.',
      hashtags_max: 'Hashtags Max.',
      posting_frequency: 'Posting Frequency',
      must_use: 'Must-Use Words',
      forbidden: 'Forbidden Words',
      brand_terms: 'Proprietary Brand Terms',
      headline_font: 'Headline Font',
      body_font: 'Body Font',
      photo_styles: 'Photo Styles',
      design_elements: 'Design Elements',
      value_proposition: 'Value Proposition',
    },
    dnaDimensions: {
      brand_identity: 'Brand Identity',
      voice_and_tone: 'Voice & Tone',
      copy_rules: 'Writing Rules',
      copy_metrics: 'Text Lengths',
      core_vocabulary: 'Brand Vocabulary',
      visual_identity: 'Visual Style',
      content_strategy: 'Content Strategy & CTAs',
    },
    dnaExtras: {
      colorPalette: 'Color Palette',
      referenceGood: 'How it should sound',
      referenceBad: 'How NOT',
      notDefined: 'Not defined',
      oneEntryPerLine: 'One entry per line',
      salutationLabel: 'Salutation',
      uploadBrandManual: 'Upload Brand Manual',
      uploadBrandManualDesc: 'Upload your Corporate Design Manual (PDF/DOCX). The AI will extract all 7 dimensions.',
      uploadPdfOrDocx: 'Upload PDF or DOCX',
      uploading: 'Uploading...',
      extractingText: 'Extracting text...',
      analyzingChars: 'AI is analyzing {chars} characters...',
      showLegacyManual: 'Show Legacy Brand Manual',
    },
    writing: {
      contentLanguage: 'Content Language',
      contentLanguageDesc: 'Default language for all platforms. Can be overridden per platform.',
      platformMapping: 'Platform mapping (optional — empty = default)',
      addressingAndTone: 'Address & Tone',
      salutation: 'Salutation',
      tonality: 'Tonality',
      tonalityPlaceholder: 'e.g. professional, warm, direct',
      formality: 'Formality',
      formalityFormal: 'formal',
      formalityNeutral: 'neutral',
      formalityInformal: 'informal',
      emojiUsage: 'Emoji usage',
      emojiNone: 'none',
      emojiSparingly: 'sparingly',
      emojiModerate: 'moderate',
      emojiPlentiful: 'plentiful',
      emojiFromAnalysis: 'Frequently used emojis (from analysis)',
      phrasesAndPatterns: 'Phrases & Patterns',
      recurringPhrases: 'Recurring Phrases',
      recurringPhrasesPh: 'e.g. We believe in, ...',
      favoriteWords: 'Favorite Words',
      favoriteWordsPh: 'e.g. innovative, sustainable',
      postOpenings: 'Post Opening Patterns',
      postOpeningsPh: 'e.g. Did you know, ...',
      forbiddenElements: 'Forbidden Elements',
      forbiddenElementsPh: 'e.g. Clickbait, exclamation marks',
      dosAndDonts: "Do's & Don'ts",
      dosLabel: "Do's — What should always appear",
      dosPh: 'e.g. provide value, concrete tips',
      dontsLabel: "Don'ts — What should never appear",
      dontsPh: 'e.g. too promotional, clickbait',
      saveWriting: 'Save writing style',
      savedToast: 'Writing style saved',
      saveFailed: 'Save failed',
    },
    channels: {
      activeChannels: 'Active Channels',
      activeChannelsDesc: 'Select the platforms you want to create content for. Only active channels appear in Creation and Production.',
      noneActive: 'No platforms activated yet. Click below to select channels.',
      availableChannels: 'Available Channels',
      ownChannels: 'Own Channels',
      newChannel: 'New Channel',
      nameRequired: 'Name required',
      addAtLeastOneField: 'Add at least one field',
      channelName: 'Channel name',
      channelNamePh: 'e.g. TikTok, Intranet, WhatsApp...',
      fieldsLabel: 'Fields',
      fieldNamePh: 'Field name (e.g. Title)',
      max: 'Max:',
      addField: 'Add field',
      createChannel: 'Create channel',
      cancel: 'Cancel',
      characterLimits: 'Character Limits',
      characterLimitsDesc: 'Custom limits per platform — in words or characters. Blog & Newsletter: freely configurable. Others: up to platform limit.',
      platform: 'Platform',
      words: 'Words',
      characters: 'Characters',
      limit: 'Limit',
      free: 'free',
      resetTitle: 'Reset',
      charsPerWordNote: '1 word ≈ 6 characters',
      saveLimits: 'Save limits',
      styleManualsPerPlatform: 'Style Manuals per platform',
      styleManualPh: 'Style Manual for {name}... Tone, structure, hashtags, typical post length',
      customStyleManualPh: 'Style Manual for {name}...',
      notActive: 'Not active',
      activateAbove: 'Activate this platform above to edit its Style Manual.',
      empty: 'Empty',
      charsBadge: 'characters',
      configSavedToast: 'Platform configuration saved',
      limitsSavedToast: 'Character limits saved',
      manualSavedToast: 'Manual saved',
      saveFailedToast: 'Save failed',
      imageFormatTitle: 'Image format',
      imageFormatDesc: 'Applies to all images newly generated for this platform from now on.',
      imageFormatDefault: 'Default',
      imageFormatPortrait: 'Portrait',
      imageAspectSavedToast: 'Image format saved',
    },
    inspirations: {
      screenshotsCard: 'Screenshots for Brand DNA Analysis',
      screenshotsDesc: 'Upload screenshots of posts or designs. The AI analyzes them for writing style and imagery.',
      uploading: 'Uploading...',
      clickToUpload: 'Click to upload',
      analyzing: 'Analyzing...',
      analyzeFromScreenshots: 'Analyze Brand DNA from screenshots',
      textInspirations: 'Text Inspirations',
      textInspirationsDesc: 'Add example posts or upload a screenshot post. The AI detects the platform automatically.',
      addTextInspiration: 'Add text inspiration',
      choosePlatformOpt: 'Choose platform (optional)',
      postTextPh: 'Post text, note or description...',
      whatILikePh: 'What do I like about it? (optional)',
      addInspiration: 'Add inspiration',
      uploadScreenshotOfPost: 'Upload screenshot of a post',
      aiExtracts: 'The AI extracts the text and detects the platform automatically.',
      analyzingImage: 'Analyzing...',
      uploadScreenshot: 'Upload screenshot',
      inspirationsCount: 'Inspirations',
      showLess: 'Show less',
      showMore: 'Show {n} more',
      showPreviousUploads: 'Show {n} previous uploads',
      saveInspirations: 'Save inspirations',
    },
    dnaSummaries: {
      words: 'words',
      mustUse: 'must-use',
      forbidden: 'forbidden',
      themes: 'themes',
    },
    products: {
      mainProduct: 'Main Product / Brand Face',
      mainProductDesc: 'Used as visual reference during image generation.',
      imageGenReference: 'Image generation reference',
      person: 'Person / Brand Face',
      product: 'Product',
      brandFaceBadge: 'Brand Face',
      productBadge: 'Product',
      activeAsReference: '✓ Active as image generation reference',
      productNamePh: 'Product name (optional)',
      personNamePh: 'Name of the person',
      shortDescPh: 'Short description (optional)',
      rolePositionPh: 'Role / Position',
      uploadingText: 'Uploading...',
      uploadPhoto: 'Upload photo',
      uploadProductImage: 'Upload product image',
      productNameRequired: 'Product name *',
      descriptionOptional: 'Description (optional)',
      addProduct: 'Add product',
      saveProducts: 'Save products',
    },
    advanced: {
      seoTitle: 'SEO — Classic Search Engine Optimization',
      seoDesc: 'Optimizes content for Google and other search engines.',
      seoEnabled: 'SEO optimization enabled',
      seoEnabledDesc: 'Turn all SEO features on or off',
      keywordsEnabled: 'Embed keywords naturally',
      keywordsEnabledDesc: 'Use relevant search terms fluently in the text',
      metaEnabled: 'Meta title & meta description',
      metaEnabledDesc: 'Only for blog and newsletter content',
      ctaEnabled: 'Include call-to-action',
      ctaEnabledDesc: 'Clear calls to action at the end of every post',
      geoTitle: 'GEO — Generative Engine Optimization',
      geoDesc: 'Optimizes content so that AI systems like ChatGPT, Perplexity and AI Overviews cite it.',
      geoEnabled: 'GEO optimization enabled',
      geoEnabledDesc: 'Turn all GEO features on or off',
      citableFacts: 'Citable facts & authority signals',
      citableFactsDesc: 'Include concrete numbers, studies and expert knowledge',
      faq: 'Answer direct questions (FAQ style)',
      faqDesc: 'Answer common questions directly and clearly',
      lists: 'Structured lists for AI extraction',
      listsDesc: 'Clear bullet points that AI systems can easily extract',
      localSeo: 'Local SEO',
      localSeoDesc: 'For local keyword optimization — optional, only if relevant.',
      city: 'City',
      region: 'Region',
      country: 'Country',
      cityPh: 'e.g. Vienna',
      regionPh: 'e.g. Vienna',
      saveSettings: 'Save settings',
      savedToast: 'Settings saved',
      saveFailed: 'Save failed',
      refreshImageUrlsTitle: 'Refresh image URLs',
      refreshImageUrlsDesc: 'If images no longer display (expired links).',
      refresh: 'Refresh',
      refreshedToast: 'All image URLs have been refreshed!',
      refreshFailedToast: 'Refresh failed',
    },
    integrations: {
      title: 'Integrations',
      description: 'Connect your social media accounts for direct posting',
      connected: 'Connected',
      notConnected: 'Not connected',
      connect: 'Connect',
      disconnect: 'Disconnect',
      hint: 'Note:',
      disconnectWarning: 'Warning — Disconnect {platform}?',
      pendingPostsWarning: '{count} scheduled post{s} reference this account.',
      afterDisconnect: 'After disconnecting, these posts will not go live until you connect a new account.',
      cancel: 'Cancel',
      disconnectAnyway: 'Disconnect anyway',
      refreshImageUrlsIntTitle: 'Refresh image URLs',
      refreshImageUrlsIntDesc: 'If images in scheduled posts no longer load (expired S3 links)',
      refreshUrls: 'Refresh URLs',
      refreshUrlsSuccess: 'All image URLs were successfully refreshed (valid for 30 days)!',
      refreshUrlsFailed: 'Failed to refresh URLs',
      prereqs: {
        instagram: 'Instagram must be a Business or Creator account (linked to a Facebook Page). Personal IG accounts cannot post.',
        facebook: 'Only Facebook Pages (not personal profiles) can post. You must be an admin of the Page.',
        tiktok: 'TikTok Business/Creator account recommended — personal accounts have stricter API limits.',
        youtube: 'The YouTube channel must be verified to allow uploads via API.',
        pinterest: 'Pinterest Business account recommended — otherwise some post types are restricted.',
      },
    },
    visual: {
      imageStyle: 'Image Style',
      imageStyleDesc: 'Determines the visual style of your generated images.',
      styleIllustrations: 'Illustrations',
      styleIllustrationsDesc: 'Digital, Flat Design',
      styleAiPeople: 'AI Photos with People',
      styleAiPeopleDesc: 'Realistically generated photos',
      stylePhotography: 'Photography',
      stylePhotographyDesc: 'Professional photo aesthetic',
      styleMixed: 'Mixed',
      styleMixedDesc: 'Depending on content topic',
      brandColorsAndMood: 'Brand Colors & Mood',
      brandColorsDesc: 'From your Brand DNA analysis. Applied when generating images.',
      primaryColors: 'Primary colors',
      colorNamePlaceholder: 'Color name (optional)',
      visualMood: 'Visual mood',
      moodPlaceholder: 'e.g. minimal, warm, modern',
      saveColorsAndMood: 'Save colors & mood',
      imagerySaved: 'Imagery saved',
      saveFailed: 'Save failed',
      logoOverlay: 'Logo Overlay',
      logoOverlayDesc: 'Logo is automatically placed on every generated image.',
      logoOverlayActive: 'Logo overlay active',
      logoLabel: 'Logo (PNG with transparency recommended)',
      clickXToReplace: 'Click × first to replace logo',
      uploadLogo: 'Upload logo',
      removeLogoTitle: 'Remove logo',
      placeLogo: 'Place logo (drag & resize)',
      bgBlack: 'Black',
      bgWhite: 'White',
    },
  },

  // Language names
  languages: {
    de: 'Deutsch',
    en: 'English',
  },

  // Toast messages
  toast: {
    savingSuccess: 'Saved successfully',
    savingError: 'Save failed',
    networkError: 'Network error — please try again',
    unauthorized: 'Session expired — please log in again',
    serverError: 'Server error — please try again later',
    copied: 'Copied to clipboard',
  },
};

export default en;